import ModerateTrip from "./ModerateTrip";

export default ModerateTrip;
